import { CHAMPION_POLICY_API_KEY_PROPERTY_TYPE_ID } from "@constants/verification-service-details-constants";
import { FormattedRpServiceConfiguration } from "@idw-types/data/rp-service-configuration";

/**
 * A challenger policy service is any service with a championPolicyApiKey property set.
 */
export const isChallengerService = (service: Pick<FormattedRpServiceConfiguration, "properties">): boolean => {
    const championApiKeyProperty = (service.properties || []).find(
        property => property.propertyTypeId === CHAMPION_POLICY_API_KEY_PROPERTY_TYPE_ID
    );

    return !!championApiKeyProperty?.addedToService && !!championApiKeyProperty.value?.trim();
};

export const getNonChallengerServices = <T extends Pick<FormattedRpServiceConfiguration, "properties">>(
    services: Array<T>
): Array<T> => {
    return services.filter(service => !isChallengerService(service));
};

export const excludeServicesByApiKeys = <T extends { apiKey: string }>(
    services: Array<T>,
    apiKeysToExclude: Array<string>
): Array<T> => {
    if (!services || !apiKeysToExclude || apiKeysToExclude.length === 0) {
        return services;
    }

    return services.filter(service => !apiKeysToExclude.includes(service.apiKey));
};

export const getChallengerServiceApiKeys = (
    services: Array<Pick<FormattedRpServiceConfiguration, "properties" | "apiKey">>
): Array<string> => {
    return services.filter(isChallengerService).map(service => service.apiKey);
};
